// extracted by mini-css-extract-plugin
export var block = "Body-module--block--exY9M";
export var root = "Body-module--root--Z75Ha";